import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchQuery, graphql } from "react-relay";
import { z } from "zod";
import type { join_inviteQuery } from "./__generated__/join_inviteQuery.graphql";
import { environment } from "@/relay/environment";

export const Route = createFileRoute("/_auth/join")({
	component: RouteComponent,
	validateSearch: z.object({
		code: z.string(),
	}),
	loaderDeps: ({ search }) => [search.code],
	loader: async ({ deps: [code], context: { club } }) => {
		if (code) {
			const data = await fetchQuery<join_inviteQuery>(
				environment,
				graphql`
     	    query join_inviteQuery($code: String!) {
      			invite(code: $code) {
              email
              code
     	        club {
     					  id
      				}
              status
              user {
                role
              }
      			}
     			}
      		`,
				{ code },
			).toPromise();

			const isInviteValid =
				data?.invite?.club?.id === club?.id &&
				data?.invite?.status === "PENDING";

			if (isInviteValid && data.invite.user.role === "authenticated") {
				throw redirect({
					to: "/login",
					search: {
						code: data.invite.code,
					},
				});
			} else if (isInviteValid) {
				throw redirect({
					to: "/cadastro",
					search: {
						code: data.invite.code,
					},
				});
			}
		}

		throw redirect({
			to: "/login",
		});
	},
});

function RouteComponent() {
	return null;
}
